import { useDispatch, useSelector } from 'react-redux'
import Page from '../../common/Page'
import PageCard from '../../common/PageCard'
import Actions from '../../../actions'
import { routes } from '../../../consts'
import $t from '../../../i18n'
import MaterialSelectWithDropDown from '../../common/MaterialSelectWithDropdown'
import { useState } from 'react'
import { Button } from 'antd'

import './Language.css'

const Language = () => {
  const dispatch = useDispatch()
  const userDetails = useSelector(state => state.profile?.userDetails)
  const languages = useSelector(state => state.app?.languages)
  const [language, setLanguage] = useState(userDetails?.language)
  const isLanguageUpdateLoading = useSelector(
    state => state.profile?.isLanguageUpdateLoading
  )
  const languagesList = languages
    ? Object.keys(languages).map(item => {
        return { value: item, label: languages[item]?.name }
      })
    : []

  const onSave = () => {
    dispatch(
      Actions.createAction(Actions.UPDATE_LANGUAGE_REQUESTED, {
        language: language,
      })
    )
  }

  return (
    <PageCard
      enableBack={true}
      onBack={() =>
        dispatch(
          Actions.createAction(
            Actions.NAVIGATED_TO,
            routes.PROFILE_ROUTE.SETTING_PREFERENCES
          )
        )
      }
    >
      <Page
        title={$t('pages.language.title')}
        subtitle={$t('pages.language.subtitle')}
        loading={isLanguageUpdateLoading}
        className="language-page"
      >
        <MaterialSelectWithDropDown
          data={languagesList}
          value={language}
          onChange={value => setLanguage(value)}
        />
        <Button
          key="1"
          className="save-language trackable"
          data-name="save-language"
          type="primary"
          onClick={onSave}
        >
          {$t('common.save')}
        </Button>
      </Page>
    </PageCard>
  )
}
export default Language
